// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
import { getAuth } from "firebase/auth";
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBAdk1pbmIr2iwIS62taSdeVCZrbvndODI",
  authDomain: "ig3n-89414.firebaseapp.com",
  projectId: "ig3n-89414",
  storageBucket: "ig3n-89414.appspot.com",
  messagingSenderId: "418597170692",
  appId: "1:418597170692:web:275b11ffd5402738680f51",
  measurementId: "G-05Y5JYLG7Q"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const auth = getAuth(app);

export default auth


//supabase
/*
Name: IG3N
db password: iDFl1P2BsDJNcluj

Anon public: eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1vYmhpeG5wbmFpbnVsY3VrbGpqIiwicm9sZSI6ImFub24iLCJpYXQiOjE2OTI3MDU3MTAsImV4cCI6MjAwODI4MTcxMH0.zM50dkPHCLc3-_u9BKaWCstN4-_kG3TDnd_EWfrEiLk

service role: eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1vYmhpeG5wbmFpbnVsY3VrbGpqIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTY5MjcwNTcxMCwiZXhwIjoyMDA4MjgxNzEwfQ.tNXguYkK1OOe8YkUgrn6v6EbEtvkiAILUKC8x44Wp54

JWT secrete: jgpb8w6ir4jhMI85zKc8Lh+NajYvR9b0zznSnJbdxB+3rd+VJg+upkcasy/kpzww4RtZ1x1oiZ4TqLW6KHS5ZA==

Url: https://mobhixnpnainulcukljj.supabase.co
*/